import { gql } from '@apollo/client'

export const UPDATE_POST = gql`
  mutation updatePost($postId: ID!) {
    updatePost(postId: $postId) {
      id
      entityId
      provider
      status
    }
  }
`

export const GET_POST_UPDATE_STATUS = gql`
  query getPostUpdateStatus($postId: ID!) {
    canUpdate(postId: $postId) {
      canUpdate
      lastUpdateAt
      hoursSinceLastUpdate
      reason
      status
    }
  }
`
